import { GameVars } from "../GameVars";

import { BoardManagerAI } from "./BoardManagerAI";

import { AudioManager } from "../AudioManager";

export class GUI extends Phaser.Group {

    private optionsButton: Phaser.Button;

    constructor(game: Phaser.Game) {

        super(game, null, "gui");

        this.optionsButton = new Phaser.Button( this.game, 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickOptions, this);
        this.optionsButton.setFrames("button_menu_on.png", "button_menu_off.png", "button_menu_on.png");
        this.optionsButton.forceOut = true;
        this.optionsButton.anchor.set(.5);
        this.optionsButton.scale.y = GameVars.scaleY;
        this.add(this.optionsButton);
    }

    public pauseLayerHidden(): void {

        this.optionsButton.visible = true;
    }

    private onClickOptions(): void {

        if (GameVars.resigning) {
            return;
        }
        
        this.optionsButton.visible = false;

        if (GameVars.againstAI) {
            BoardManagerAI.onClickPause();
        }

        AudioManager.playSound("click"); 
    }
}
